import { IContractAddress } from '../entities/IContractAddress';
import { IContractor } from '../entities/IContractor';
import { PersonTypeEnum } from '../enums/PersonTypeEnum';
import { httpClient } from './helper/httpClient';

export interface ICreateContractorParams {
  personType: PersonTypeEnum;
  name: string;
  documentNumber: string;
  legalRepresentativeName?: string;
  legalRepresentativeDocument?: string;
  email?: string;
  phone?: string;
  instagram?: string;
  address?: IContractAddress;
}

export interface IUpdateContractorParams {
  personType?: PersonTypeEnum;
  name?: string;
  documentNumber?: string;
  legalRepresentativeName?: string;
  legalRepresentativeDocument?: string;
  email?: string;
  phone?: string;
  instagram?: string;
  address?: IContractAddress | null;
}

class ContractorService {
  private _baseURL = 'contractors';

  create(data: ICreateContractorParams): Promise<IContractor> {
    return httpClient.post<null, IContractor>(this._baseURL, { ...data });
  }

  getAll(): Promise<IContractor[]> {
    return httpClient.get<null, IContractor[]>(this._baseURL);
  }

  getById(id: string): Promise<IContractor> {
    return httpClient.get<null, IContractor>(`${this._baseURL}/${id}`);
  }

  update(id: string, data: IUpdateContractorParams): Promise<void> {
    return httpClient.patch(`${this._baseURL}/${id}`, { ...data });
  }

  remove(id: string): Promise<void> {
    return httpClient.delete(`${this._baseURL}/${id}`);
  }
}

export default new ContractorService();
